function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "kfnh49zb3a",
  d: "M8.182 0c.252 0 .502.08.748.24.246.16.417.353.511.58l.663 1.541h2.926c.089 0 .161.028.218.083.057.055.085.126.085.212v.59c0 .087-.028.157-.085.213-.057.055-.13.083-.218.083h-.909v8.743c0 .51-.148.952-.445 1.324-.296.372-.653.558-1.07.558H2.727c-.416 0-.773-.18-1.07-.54-.297-.36-.445-.794-.445-1.305v-8.78H.303c-.088 0-.161-.028-.218-.083C.028 3.403 0 3.333 0 3.246v-.59c0-.086.028-.157.085-.212.057-.055.13-.083.218-.083h2.926l.663-1.54C3.987.593 4.157.4 4.403.24 4.65.08 4.9 0 5.151 0zm2.727 3.542H2.424v8.743c0 .135.022.26.066.374.045.113.09.196.138.249.047.052.08.078.1.078h7.878c.02 0 .052-.026.1-.078.047-.053.093-.136.137-.25.044-.113.066-.237.066-.373V3.542zm-5.53 1.77c.088 0 .16.028.218.083.056.056.085.127.085.213v5.312c0 .086-.029.157-.085.212-.057.056-.13.083-.218.083h-.606c-.089 0-.161-.027-.218-.083-.057-.055-.085-.126-.085-.212V5.608c0-.086.028-.157.085-.213.057-.055.13-.082.218-.082zm3.257 0c.089 0 .161.028.218.083.057.056.085.127.085.213v5.312c0 .086-.028.157-.085.212-.057.056-.13.083-.218.083H8.03c-.088 0-.16-.027-.217-.083-.057-.055-.086-.126-.086-.212V5.608c0-.086.029-.157.086-.213.056-.055.129-.082.217-.082zM8.172 1.18H5.17c-.063.013-.116.046-.16.102L4.544 2.36h4.243l-.455-1.08c-.044-.054-.098-.088-.16-.1z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-584 -469) translate(0 204) translate(46 216) translate(232 48) translate(306 1) translate(3.333 2.917)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "iwtupjgeib",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#kfnh49zb3a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#5D5D5D",
  fillRule: "nonzero",
  xlinkHref: "#kfnh49zb3a"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#444",
  mask: "url(#iwtupjgeib)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H20V20H0z",
  transform: "translate(-3.333 -2.917)"
}))))))))));

var SvgLixeira = function SvgLixeira(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLixeira, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lixeira.b65cf316.svg";
export { ForwardRef as ReactComponent };